export type CocoonFeature = {
	id: string
	category: 'equipment' | 'services'
	isSearchFilter?: boolean
}

export const cocoonFeatures: CocoonFeature[] = [
	{ category: 'equipment', id: 'tv', isSearchFilter: true },
	{ category: 'equipment', id: 'video_projector', isSearchFilter: true },
	{ category: 'equipment', id: 'air_conditioning', isSearchFilter: true },
	{ category: 'equipment', id: 'paperboard' },
	{ category: 'equipment', id: 'whiteboard' },
	{ category: 'equipment', id: 'hdmi_adapter' },
	{ category: 'equipment', id: 'sound_system' },
	{ category: 'services', id: 'coffee', isSearchFilter: true },
	{ category: 'services', id: 'water', isSearchFilter: true },
	{ category: 'services', id: 'wifi' },
	{ category: 'services', id: 'restroom' },
	{ category: 'services', id: 'disabled_access' },
	{ category: 'services', id: 'elevator', isSearchFilter: true },
]
